import {
  createBrowserRouter,
  RouteObject,
  RouterProvider,
} from "react-router-dom";
import { Appointment, Form, Auth, AuthPage, Policy } from "../../pages";
import { Service } from "../../widgets";
import { Doctor } from "../../widgets/Doctor";
import {Schedule} from '../../widgets/Schedule/Schedule'
import { AdminLogin } from "../../pages/AdminLogin";
import { AdminDashboard } from "../../pages/AdminDashboard";
import { StatisticsDashboard } from "../../pages/StatisticsDashboard";
import { ClientsAnalytics } from "../../pages/ClientsAnalytics";
import { SpecialistsManagement } from "../../pages/SpecialistsManagement";
import { AdminSettings } from "../../pages/AdminSettings";
import { AdminUploadHistory } from "../../pages/AdminUploadHistory";
import { BookingRatings } from "../../pages/BookingRatings";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Auth />,
  },
  {
    path: "/policy",
    element: <Policy />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin/dashboard",
    element: <AdminDashboard />,
  },
  {
    path: "/admin/statistics",
    element: <StatisticsDashboard />,
  },
  {
    path: "/admin/ratings",
    element: <BookingRatings />,
  },
  {
    path: "/admin/clients",
    element: <ClientsAnalytics />,
  },
  {
    path: "/admin/specialists",
    element: <SpecialistsManagement />,
  },
  {
    path: "/admin/settings",
    element: <AdminSettings />,
  },
  {
    path: "/admin/services-upload-history",
    element: <AdminUploadHistory />,
  },
  {
    element: <AuthPage />,
    children: [
      {
        element: <Appointment />,
        children: [
          {
            path: "/service",
            element: <Service />,
          },
          {
            path: "/service/:name", // ✅ ДОБАВЛЕН
            element: <Doctor />,
          },
          {
            //path: "/doctor/:serviceId",
            path: "/doctor/:name",
            element: <Doctor />,
          },
          {
            // Персональная ссылка врача: список врачей, но только один врач.
            path: "/doctor/id/:doctorId",
            element: <Doctor />,
          },
          {
            path: "/form/:siteId",
            element: <Form />,
          },
          {
            path: "/form",
            element: <Form />,
          },
          {
            path: "/schedule",
            element: <Schedule />,
          }
        ],
      },
    ],
  },
];

const router = createBrowserRouter(routes);

export function Router() {
  return <RouterProvider router={router} />;
}
